import * as React from 'react';
import { useTranslation } from '@r360-tours/core';
import { ResetPassword } from '@r360-tours/ui';
import { LoginLink, SignupLink } from '../../components/link';
import * as LinkStyled from '../../components/login-form-links/login-form-links.styled';
import * as Styled from './reset.styled';

const Reset: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const onResetPasswordSuccessClick = () => {
    window.location.href = '/login';
  };
  const links = (
    <LinkStyled.Links>
      <LoginLink>
        <a>{t('ResetPassword.Login')}</a>
      </LoginLink>{' '}
      {t('ResetPassword.Or')}{' '}
      <SignupLink>
        <a>{t('ResetPassword.SignUp')}</a>
      </SignupLink>
    </LinkStyled.Links>
  );
  const title = <Styled.Title>{t('RequestCodeForm.Title')}</Styled.Title>;

  return (
    <ResetPassword
      links={links}
      onResetPasswordSuccessClick={onResetPasswordSuccessClick}
      title={title}
    />
  );
};

export default Reset;
